import { Loadable, LoadableFactory } from "shared/loadable";

import { CurrentUserData } from "./currentUserHelper";

export type CurrentUserState = Loadable<CurrentUserData>;

export const initialCurrentUserState: Loadable<CurrentUserData> =
  LoadableFactory.reset();
